import styled, { css } from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { colors } from "healthex-common/colors";
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { fontWeights } from "healthex-common/weights";
import { fontSizes } from "healthex-common/sizes";
import { mobilePageMaxWidth } from "./HXMobilePage.styles";
import { SlideFromLeftCSSTransitionCSSMixin } from "./SlideFromLeftCSSTransition";
import { HXButton } from "./HXButton";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
export const BannerContainer = styled(FlexRowDiv) `
    position: fixed;
    width: ${(props) => (props.isMobile ? "auto" : "100%")};
    max-width: ${(props) => (props.isMobile ? `${mobilePageMaxWidth}px` : "100%")};
    bottom: 0;
    left: auto;
    right: auto;
    z-index: 1500; // Dialogs are 1300
    padding: 0 16px 27px 16px;

    ${SlideFromLeftCSSTransitionCSSMixin}
`;
export const BannerTitleAndText = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const Banner = styled(FlexRowDiv) `
    padding: 13px 16px;
    align-items: center;
    background-color: ${colors.forest_main};
    gap: 12px;
    border-radius: 4px;
    max-width: 90%;

    ${(props) => props.bannerType === "ERROR" &&
    css `
            background-color: ${colors.tulip_main};
        `}

    ${(props) => props.bannerType === "WARNING" &&
    css `
            background-color: ${colors.sunset_main};
        `}

    ${(props) => props.bannerType === "INFO" &&
    css `
            background-color: ${colors.navy_main};
            & svg {
                align-self: flex-start;
            }
        `}
`;
export const BannerTitle = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.white_main};
    letter-spacing: 0.15px;
`;
export const BannerText = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.white_main};
    letter-spacing: 0.15px;

    ${(props) => props.bannerType === "WARNING" &&
    css `
            color: ${colors.black_main};
        `}

    ${(props) => !!props.title &&
    css `
            font-weight: ${fontWeights.NORMAL};
        `}
`;
export const CheckCircleOutlinedIcon = styled(CheckCircleOutlined) `
    width: 22px;
    height: 22px;
    color: ${colors.white_main};
`;
export const ErrorOutlineIcon = styled(ErrorOutline) `
    width: 22px;
    height: 22px;
    color: ${colors.white_main};
`;
export const WarningAmberOutlinedIcon = styled(WarningAmberOutlined) `
    width: 22px;
    height: 22px;
    color: ${colors.black_main};
`;
export const InfoOutlinedIcon = styled(InfoOutlined) `
    width: 22px;
    height: 22px;
    color: ${colors.white_main};
`;
export const CTAButton = styled(HXButton) `
    color: ${colors.white_main};
    padding: 0px 12px;

    ${(props) => props.bannerType === "WARNING" &&
    css `
            color: ${colors.navy_main};
        `}
`;
